import CheckOutlined from '@mui/icons-material/CheckOutlined';
import CopyAllOutlined from '@mui/icons-material/CopyAllOutlined';
import React from 'react'
import Tooltip from 'src/components/Tooltip';
import { ReactComponent as UserIcon } from 'src/assets/icons/paula-user-icon.svg';
interface messageType {
  content: string;
}
const SimpleText: React.FC<messageType> = ({ content }) => {
  const [showCopied, setShowCopied] = React.useState(false);
  const [isMessageHovered, setIsMessageHovered] = React.useState(false);
  const handleCopy = (liveUrl: string) => {
    navigator.clipboard.writeText(liveUrl);
  };
  function formatShorthandNumbers(text: string) {
    return text.replace(/\b\d{5,}\b/g, (match) => {
      const num = parseInt(match, 10);
      if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
      if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
      if (num >= 10_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
      return match;
    });
  }

  return (
    <>
      <div className="simple-text-container">
        <div
          className="content"
          onMouseEnter={() => setIsMessageHovered(true)}
          onMouseLeave={() => setIsMessageHovered(false)}
        >
          {formatShorthandNumbers(content)}
          <div className="copy-icon">
            {showCopied && isMessageHovered ? (
              <Tooltip title="Copied" placement="top">
                <CheckOutlined
                  style={{
                    cursor: 'pointer',
                    height: '12px',
                    width: '12px',
                  }}
                />
              </Tooltip>
            ) : (
              isMessageHovered && (
                <Tooltip title="Copy" placement="top" open>
                  <CopyAllOutlined
                    onClick={() => {
                      const copyContent = content;
                      handleCopy(copyContent);
                      setShowCopied(true);
                      setTimeout(() => {
                        setShowCopied(false);
                      }, 700);
                    }}
                    style={{
                      cursor: 'pointer',
                      height: '12px',
                      width: '12px',
                    }}
                  />
                </Tooltip>
              )
            )}
          </div>
        </div>
        <UserIcon />
      </div>
    </>
  );
};

export default SimpleText;
